import {
	getTableData,
	saveAboutBASF,
	editAboutBASF,
	getDetail,
	updateHiddenApi
} from '@/axios/api/aboutBASF'
import { Message } from 'element-ui'


const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const CLEAR_CHECKED = 'CLEAR_CHECKED'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_DETAIL = 'UPDATE_DETAIL'


const state = {
	tableData: [],
	tblLoading: false,
	detailLoading: false,
	pager: {
		current: 1,
		size: 10,
		total: 0
	},
	params: {
		id: '',
		contactorName: '',
		email: '',
		isExpert: ''
	},
	detail: {
		id: '',
		fileId: '',
		contactorName: '',
		title: '',
		email: '',
		pdfFileId: '',
		isExpert: 0,
		weight: ''
	}
}



const getters = {
	pager: state => state.pager,
	params: state => state.params,
	tableData: state => state.tableData,
	tblLoading: state => state.tblLoading,
	detailLoading: state => state.detailLoading,
	detail: state => state.detail
}

const mutations = {
	[UPDATE_SEARCH](state, { pager, params }) {
		state.pager = { ...state.pager, ...pager }
		if (params) state.params = params
	},
	[UPDATE_PARAMS](state, params) {
		state.params = { ...state.params, params }
	},
	[UPDATE_TOTAL](state, total) {
		state.pager = { ...state.pager, total }
	},
	[UPDATE_TBL_LOADING](state, tblLoading) {
		state.tblLoading = tblLoading
	},
	[UPDATE_DET_LOADING](state, detailLoading) {
		state.detailLoading = detailLoading
	},
	[CLEAR_CHECKED](state) {
		// 清空模态框
	},
	[UPDATE_TABLEDATA](state, tableData) {
		state.tableData = tableData
	},
	[UPDATE_DETAIL](state, detail) {
		state.detail = detail
	}
}

const actions = {
	// 获取列表数据
	async getTableDataApi({ commit }, params) {
		commit(UPDATE_TBL_LOADING, true)
		try {
			let { data: res } = await getTableData(params)
			commit(UPDATE_TABLEDATA, res.records)
			commit(UPDATE_TOTAL, res.total)
		} catch (e) { }
		commit(UPDATE_TBL_LOADING, false)
	},
	// 设置筛选条件
	setParamsApi({ commit }, params) {
		commit(UPDATE_PARAMS, params)
	},
	// 清空搜索条件
	clearSearchApi({ state, commit }) {
		const pager = {
			...state.pager,
			current: 1
		}
		const params = {
			...state.params,
			id: '',
			contactorName: '',
			email: '',
			isExpert: ''
		}
		commit(UPDATE_SEARCH, { pager, params })
	},
	changeLoadingApi({ commit }, flag) {
		commit(UPDATE_DET_LOADING, flag)
	},
	// 设置page
	setPagerApi({ commit }, pager) {
		commit(UPDATE_SEARCH, { pager })
	},
	// 新增aboutBASF
	async saveAboutBASFApi({ commit }, params) {
		commit(UPDATE_DET_LOADING, true)
		try {
			await saveAboutBASF(params)
			Message.success('success')
			commit(UPDATE_DET_LOADING, false)
			return true
		} catch (e) {
			commit(UPDATE_DET_LOADING, false)
			return false
		}
	},
	// 编辑aboutBASF
	async editAboutBASFApi({ commit }, params) {
		commit(UPDATE_DET_LOADING, true)
		try {
			await editAboutBASF(params)
			Message.success('success')
			commit(UPDATE_DET_LOADING, false)
			return true
		} catch (e) {
			commit(UPDATE_DET_LOADING, false)
			return false
		}
	},
	async getDetailApi({ commit }, params) {
		commit(UPDATE_DET_LOADING, true)
		try {
			const { data: res } = await getDetail(params)
			// const { id,fileId,contactorName,title,email,pdfFileId,isExpert,weight } = data
			commit(UPDATE_DETAIL, res)
		} catch (e) { }
		commit(UPDATE_DET_LOADING, false)
	},
	async updateHidden({ commit }, params) {
		commit(UPDATE_TBL_LOADING, true)
		try {
			await updateHiddenApi(params)
			Message.success('success')
			return true

		} catch (e) {
			return false
		}
		commit(UPDATE_TBL_LOADING, false)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/aboutBASF.js